module.exports = __webpack_public_path__ + "static/img/energy.cf35d6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/energy.png
// module id = xZ6o
// module chunks = 4